export default __webpack_public_path__ + "d3744b91d6b5e78a93c66456c4c16110.svg";